import {jobActions, titleActions} from "../actionTypes";

import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `titleActions.js`);



/** ---------------- action creators ---------------- */
const getTitlesRequest = () => ({
  type: titleActions.GET_TITLES_REQUEST,
});


const removeTitleRequest = (_id) => ({
  type: titleActions.DELETE_TITLE_REQUEST,
  _id,
});

const createTitleRequest = (config) => ({
  type: titleActions.POST_TITLE_REQUEST,
  ...config,
});

const updateTitleRequest = (id, title) => ({
  type: titleActions.PUT_TITLE_REQUEST,
  id,
  ...title,
});

/** ---------------- action sequences ---------------- */

const getTitles = () => {
  return (dispatch) => {
    return dispatch(getTitlesRequest());
  }
};

const removeTitle = (_id) => {
  return (dispatch) => {
    return dispatch(removeTitleRequest(_id));
  }
};

const createTitle = (config) => {
  return (dispatch) => {
    debug.enter(`createTitle`);
    return dispatch(createTitleRequest({
      ...config,
    }));
  };
};

const updateTitle = (id, title) => {
  return (dispatch) => {
    debug.enter(`updateTitle`);
    return dispatch(updateTitleRequest(id, {...title}))
  }
};


export {
  getTitles,
  removeTitle,
  createTitle,
  updateTitle,
};



// WEBPACK FOOTER //
// ./src/data/titles/titleActions.js